import * as CryptoJS from 'crypto-js'

export const useEncrypt = () => {

  const encrypt = (value: string) => {
      if(value !== "" && value !== null){
        let ciphertext = CryptoJS.AES.encrypt(value, 'My*Clave*Secreta').toString();
        return ciphertext;
      }
  };

  const decrypt = (value: any) => {
    if(value !== "" && value !== null){
        let bytes  = CryptoJS.AES.decrypt(value, 'My*Clave*Secreta');
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        return originalText;
    }
  };

  return { decrypt , encrypt };
};

  


